// import { Box, Typography } from '@mui/material';
// import React, { useState, useEffect } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import Header from '../../components/Header';

// const ApplyLeave = () => {
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [startHalfDay, setStartHalfDay] = useState(false);
//   const [endHalfDay, setEndHalfDay] = useState(false);
//   const [startHalfDayOption, setStartHalfDayOption] = useState('0');
//   const [endHalfDayOption, setEndHalfDayOption] = useState('0');
//   const [leaveType, setLeaveType] = useState('');
//   const [leaveReason, setLeaveReason] = useState('');
//   const [userEmail, setUserEmail] = useState("UserEmail");
//   const [EmergencyLeave, setEmergencyLeave] = useState(0);
//   const [PlannedLeave, setPlannedLeave] = useState(0);
//   const [Leavewithoutpay, setLeavewithoutpay] = useState(0);
//   const [showFileUpload, setShowFileUpload] = useState(false);
//   const [files, setFiles] = useState([]);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [formData, setFormData] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [username, setUsername] = useState("");

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/Balanceleave?UserEmail=${userEmail}`)
//       .then(response => response.json())
//       .then(data => {
//         if (Array.isArray(data) && data.length > 0) {
//           const balanceLeave = data[0];
//           console.log("Fetched userName from backend:", balanceLeave?.userName);

//           setUsername(balanceLeave?.userName || "");
//           setEmergencyLeave(balanceLeave?.emergencyleave || 0);
//           setPlannedLeave(balanceLeave?.plannedleave || 0);
//           setLeavewithoutpay(balanceLeave?.Leavewithoutpay || 0);
//           console.log("Fetched userName from backend:", balanceLeave?.userName);
//         }

//       })
//       .catch(error => console.log(error));
//   }, [userEmail]);

//   useEffect(() => {
//     setUserEmail(localStorage.getItem("UserEmail"));
//     setUsername(localStorage.getItem("UserName"));
//     console.log(localStorage.getItem("UserEmail"));
//     console.log(localStorage.getItem("UserName"));
//   }, []);

//   const handleStartDateChange = (date) => {
//     setStartDate(date);
//     calculateDateDifference(date, endDate,leaveType); // Recalculate date difference
//   };

//   const handleEndDateChange = (date) => {
//     setEndDate(date);
//     calculateDateDifference(startDate, date, leaveType); // Recalculate date difference
//   };

//   const calculateDateDifference = (start, end) => {
//     const differenceInTime = end.getTime() - start.getTime();
//     const differenceInDays = differenceInTime / (1000 * 3600 * 24);
//     setShowFileUpload(differenceInDays > 2); // Show file upload if difference > 2 days
//   };

//   const handleStartHalfDayChange = () => {
//     setStartHalfDay(!startHalfDay);
//   };

//   const handleEndHalfDayChange = () => {
//     setEndHalfDay(!endHalfDay);
//   };

//   const handleStartHalfDayOptionChange = (e) => {
//     setStartHalfDayOption(e.target.value);
//   };

//   const handleEndHalfDayOptionChange = (e) => {
//     setEndHalfDayOption(e.target.value);
//   };

//   const checkFileUploadRequirement = (start, end, type) => {
//     if (type === "EMERGENCY" && start && end) {
//         const startDateObj = new Date(start);
//         const endDateObj = new Date(end);
//         const diffDays = (endDateObj - startDateObj) / (1000 * 60 * 60 * 24);

//         setShowFileUpload(diffDays >= 1); // Updated: Show file upload if leave is **1 or more** days
//     } else {
//         setShowFileUpload(false);
//     }
// };

//   const handleLeaveTypeChange = (e) => {
//     setLeaveType(e.target.value);
//     checkFileUploadRequirement(startDate, endDate, e.target.value);
//   };

//   const handleLeaveReasonChange = (e) => {
//     setLeaveReason(e.target.value);
//   };

//   const handleFileChange = (e) => {
//     setFiles([...e.target.files]); // Store uploaded files
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     if (!leaveType) {
//       alert("Please select leave type from the dropdown.");
//       return;
//     }
//     if (!leaveReason) {
//       alert("Please, fill up leave reason.");
//       return;
//     }

//     if (showFileUpload && files.length === 0) {
//       alert("Please upload a file for emergency leave.");
//       setIsSubmitting(false);
//       return;
//     }

//     const formData = new FormData();
//     formData.append('leaveType', leaveType);
//     formData.append('startDate', startDate.getDate() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getFullYear());
//     formData.append('endDate', endDate.getDate() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getFullYear());
//     formData.append('startHalfDayOption', startHalfDayOption);
//     formData.append('endHalfDayOption', endHalfDayOption);
//     formData.append('leaveReason', leaveReason);
//     formData.append('userEmail', userEmail);
//     formData.append('username', username);

//     // Append files if they exist
//     files.forEach((file, index) => {
//       formData.append(`file${index + 1}`, file);
//       console.log("Sending username:", username);
//     });

//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/ApplyLeave`, {
//         method: 'POST',
//         body: formData, // Send form data
//       });

//       const data = await response.json();
//       if (response.status === 400) {
//         alert(data.message);
//       }
//       if (response.ok) {
//         setFormData(formData);
//         setSuccessMessage(data.message);
//         setIsSubmitted(true);
//       } else {
//         setErrorMessage(data.message);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setIsSubmitting(false);
//   };

//   const handleReset = () => {
//     setStartDate(new Date());
//     setEndDate(new Date());
//     setStartHalfDayOption('0');
//     setEndHalfDayOption('0');
//     setLeaveType('');
//     setLeaveReason('');
//     setFiles([]);
//     setShowFileUpload(false);
//   };

//   if (isSubmitted) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//         <Box style={{ maxWidth: '600px', width: '100%', padding: '40px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0px 0px 5px #ccc' }}>
//           <Typography variant="h4" align="center" gutterBottom>{successMessage}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Email:</strong> {userEmail}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>name </strong> {username}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Start Date:</strong> {startDate.getDate() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getFullYear()}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>End Date:</strong> {endDate.getDate() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getFullYear()}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Reason:</strong> {leaveReason}</Typography>
//         </Box>
//       </Box>
//     );
//   }

//   return (
//     <Box m="20px">
//       <Header title="Apply For Leave" subtitle="You Can Apply Leave From Here" />
//       {successMessage && <p>{successMessage}</p>}
//         <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0',fontSize: '20px', fontWeight: 'bold' }}>
//           <p>EL: {EmergencyLeave} | PL: {PlannedLeave} | LWP: {Leavewithoutpay}</p>
//         </div>
//       <Box display="flex"  justifyContent="center" alignItems="center" minHeight="40vh">
//         <form onSubmit={handleSubmit} style={{ maxWidth: '600px', width: '100%', padding: '40px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0px 0px 5px #ccc',marginTop: '0'}}>
//           {/* Start Date and Half Day */}
//           <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <label htmlFor="startDate" style={{ paddingRight: '10px', width: '120px' }}>Start Date:</label>
//               <DatePicker selected={startDate} onChange={handleStartDateChange} dateFormat="dd/MM/yyyy" />
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <label htmlFor="startHalfDay" style={{ paddingRight: '10px', width: '100px' }}>Half Day:</label>
//               <input
//                 type="checkbox"
//                 id="startHalfDay"
//                 name="startHalfDay"
//                 checked={startHalfDay}
//                 onChange={handleStartHalfDayChange}
//               />
//             </div>
//           </Box>
//           {startHalfDay && (
//             <Box marginLeft={39}>
//               <label style={{ paddingRight: '10px' }}>
//                 <input
//                   type="radio"
//                   name="startHalfDayOption"
//                   value="1"
//                   checked={startHalfDayOption === '1'}
//                   onChange={handleStartHalfDayOptionChange}
//                 />
//                 First Half
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   name="startHalfDayOption"
//                   value="2"
//                   checked={startHalfDayOption === '2'}
//                   onChange={handleStartHalfDayOptionChange}
//                 />
//                 Second Half
//               </label>
//             </Box>
//           )}

//           {/* End Date and Half Day */}
//           <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <label htmlFor="endDate" style={{ paddingRight: '10px', width: '120px' }}>End Date:</label>
//               <DatePicker selected={endDate} onChange={handleEndDateChange} minDate={startDate} dateFormat="dd/MM/yyyy" />
//             </div>
//             {startDate.toDateString() !== endDate.toDateString() && (
//               <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <label htmlFor="endHalfDay" style={{ paddingRight: '1px', width: '100px' }}>Half Day:</label>
//                 <input
//                   type="checkbox"
//                   id="endHalfDay"
//                   name="endHalfDay"
//                   checked={endHalfDay}
//                   onChange={handleEndHalfDayChange}
//                 />
//               </div>
//             )}
//           </Box>
//           {endHalfDay && (
//             <Box marginLeft={39}>
//               <label style={{ paddingRight: '10px' }}>
//                 <input
//                   type="radio"
//                   name="HalfDayOption"
//                   value="1"
//                   checked={endHalfDayOption === '1'}
//                   onChange={handleEndHalfDayOptionChange}
//                 />
//                 First Half
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   name="endHalfDayOption"
//                   value="2"
//                   checked={endHalfDayOption === '2'}
//                   onChange={handleEndHalfDayOptionChange}
//                 />
//                 Second Half
//               </label>
//             </Box>
//           )}

//           {/* Leave Type Dropdown */}
//           <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
//             <label htmlFor="dropdown" style={{ paddingRight: '17px' }}>Leave Type:</label>
//             <select id="dropdown" defaultValue={leaveType} onChange={handleLeaveTypeChange}>
//               <option value="" disabled>Select an option</option>
//               <option value="EMERGENCY">EMERGENCY</option>
//               <option value="PLANNED">PLANNED</option>
//               <option value="LWP" disabled={EmergencyLeave > 0 || PlannedLeave > 0}>LWP</option>
//             </select>
//           </Box>

//           {/* Leave Reason Input */}
//           <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
//             <label htmlFor="textInput" style={{ paddingRight: '38px' }}>Reason</label>
//             <input type="text" id="textInput" value={leaveReason} onChange={handleLeaveReasonChange} />
//           </Box>

//           {/* File Upload (Conditional) */}
//           {(showFileUpload && leaveType === "EMERGENCY") && (
//             <Box style={{ marginBottom: '20px' }}>
//               <label htmlFor="fileUpload">Upload Supporting Documents: </label>
//               <input
//                 type="file"
//                 id="fileUpload"
//                 multiple
//                 onChange={handleFileChange}
//               />
//             </Box>
//           )}

//           {/* Submit and Reset Buttons */}
//           <Box style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
//             <button type="submit" disabled={isSubmitting}>Submit</button>
//             <button type="button" onClick={handleReset}>Reset</button>
//           </Box>
//         </form>
//       </Box>
//     </Box>
//   );
// };

// export default ApplyLeave;

// import { Box, Typography, TextField, MenuItem, Button, Checkbox, FormControlLabel, Grid, AppBar, Toolbar, useTheme, useMediaQuery } from '@mui/material';
// import { tokens } from "../../theme";
// import React, { useState, useEffect } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import Header from '../../components/Header';
// import EventOutlinedIcon from '@mui/icons-material/EventOutlined';

// const ApplyLeave = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const isSmallScreen = useMediaQuery("(max-width: 900px)");
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [isHalfDay, setIsHalfDay] = useState(false);
//   const [leaveType, setLeaveType] = useState('');
//   const [leaveReason, setLeaveReason] = useState('');
//   const [userEmail, setUserEmail] = useState("UserEmail");
//   const [EmergencyLeave, setEmergencyLeave] = useState(0);
//   const [PlannedLeave, setPlannedLeave] = useState(0);
//   const [Leavewithoutpay, setLeavewithoutpay] = useState(0);
//   const [totalBalanceLeave, setTotalBalanceLeave] = useState(0);
//   const [files, setFiles] = useState([]);
//   const [totalLeaveDays, setTotalLeaveDays] = useState(0);

//   // Employee details
//   const [employeeId, setEmployeeId] = useState("HR-LMP-00001");
//   const [employeeName, setEmployeeName] = useState("George Smith");

//   // Form submission states
//   const [successMessage, setSuccessMessage] = useState('');
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/Balanceleave?UserEmail=${userEmail}`)
//       .then(response => response.json())
//       .then(data => {
//         if (Array.isArray(data) && data.length > 0) {
//           const balanceLeave = data[0];
//           setEmergencyLeave(balanceLeave?.emergencyleave || 0);
//           setPlannedLeave(balanceLeave?.plannedleave || 0);
//           setLeavewithoutpay(balanceLeave?.Leavewithoutpay || 0);
//           setTotalBalanceLeave(balanceLeave?.annualleave || 0);
//         }
//       })
//       .catch(error => console.log(error));
//   }, [userEmail]);

//   useEffect(() => {
//     setUserEmail(localStorage.getItem("UserEmail"));
//     fetchEmployeeDetails(localStorage.getItem("UserEmail"));
//     calculateTotalDays(startDate, endDate);
//   }, []);

//   const fetchEmployeeDetails = async (email) => {
//     try {
//       const response = await fetch('http://127.0.0.1:5000/lms/get-employee-details', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ "email": email })
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setEmployeeId(data.employee_id);
//         setEmployeeName(data.full_name);
//       }
//     } catch (error) {
//       console.error('Error fetching employee details:', error);
//     }
//   };

//   const handleStartDateChange = (date) => {
//     setStartDate(date);
//     calculateTotalDays(date, endDate);
//   };

//   const handleEndDateChange = (date) => {
//     setEndDate(date);
//     calculateTotalDays(startDate, date);
//   };

//   const calculateTotalDays = async (start, end) => {
//     const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/count-no-of-days`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         start_date: start.toISOString().split('T')[0],
//         end_date: end.toISOString().split('T')[0],
//         half_day_start: isHalfDay,
//         half_day_end: isHalfDay
//       })
//     });

//     const data = await response.json();
//     setTotalLeaveDays(data.total_days);
//   };

//   const handleHalfDayChange = (e) => {
//     setIsHalfDay(e.target.checked);
//     setTotalLeaveDays(e.target.checked ? totalLeaveDays - 0.5 : totalLeaveDays);
//   };

//   const handleLeaveTypeChange = (e) => {
//     setLeaveType(e.target.value);
//   };

//   const handleLeaveReasonChange = (e) => {
//     setLeaveReason(e.target.value);
//   };

//   const handleFileChange = (e) => {
//     setFiles([...e.target.files]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     // Validation checks
//     if (!leaveType) {
//       alert("Please select leave type from the dropdown.");
//       setIsSubmitting(false);
//       return;
//     }
//     if (!leaveReason) {
//       alert("Please, fill up leave reason.");
//       setIsSubmitting(false);
//       return;
//     }

//     const formData = new FormData();
//     formData.append('leaveType', leaveType);
//     formData.append('startDate', startDate.getDate() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getFullYear());
//     formData.append('endDate', endDate.getDate() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getFullYear());
//     formData.append('isHalfDay', isHalfDay);
//     formData.append('leaveReason', leaveReason);
//     formData.append('userEmail', userEmail);

//     files.forEach((file, index) => {
//       formData.append(`file${index + 1}`, file);
//     });

//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/ApplyLeave`, {
//         method: 'POST',
//         body: formData,
//       });

//       const data = await response.json();

//       if (response.status === 400) {
//         alert(data.message);
//         setIsSubmitting(false);
//         return;
//       }

//       if (response.ok) {
//         setSuccessMessage(data.message);
//         setIsSubmitted(true);
//       }
//     } catch (error) {
//       console.log(error);
//       alert("An error occurred while submitting the form. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleReset = () => {
//     setStartDate(new Date());
//     setEndDate(new Date());
//     setIsHalfDay(false);
//     setLeaveType('');
//     setLeaveReason('');
//     setFiles([]);
//     setTotalLeaveDays(0);
//     setIsSubmitted(false);
//   };

//   const formatDate = (date) => {
//     return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
//   };

//   return (
//     <Box m="20px">
//       {/* HEADER */}
//       <Box display="flex" flexDirection={isSmallScreen ? "column" : "row"} justifyContent="space-between" alignItems={isSmallScreen ? "flex-start" : "center"}>
//         <Header title="APPLY LEAVE" subtitle="Submit a new leave application" />
//       </Box>

//       {/* LEAVE BALANCE CARDS */}

//       <div style={{display:"flex" , alignItems:"center" , justifyContent:"center" ,flexDirection:"column"}}>

//       <Box
//         display="grid"
//         gridTemplateColumns={isSmallScreen ? "1fr" : "repeat(3, 1fr)"}
//         gap="20px"
//         mb="20px"
//         width="100%"
//         maxWidth="900px"

//       >
//         <Box
//           backgroundColor={colors.primary[400]}
//           p="20px"
//           borderRadius="4px"
//           boxShadow={theme.shadows[1]}
//           display="flex"
//           flexDirection="column"
//         >
//           <Box display="flex" alignItems="center" justifyContent="space-between">
//             <Typography variant="h5" fontWeight="600" color={colors.grey[100]}>
//               Emergency Leave
//             </Typography>
//             <EventOutlinedIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />
//           </Box>
//           <Box display="flex" alignItems="center" justifyContent="space-between" mt="10px">
//             <Typography variant="h3" fontWeight="bold" color={colors.greenAccent[500]}>
//               {EmergencyLeave}
//             </Typography>
//           </Box>
//         </Box>

//         <Box
//           backgroundColor={colors.primary[400]}
//           p="20px"
//           borderRadius="4px"
//           boxShadow={theme.shadows[1]}
//           display="flex"
//           flexDirection="column"
//         >
//           <Box display="flex" alignItems="center" justifyContent="space-between">
//             <Typography variant="h5" fontWeight="600" color={colors.grey[100]}>
//               Planned Leave
//             </Typography>
//             <EventOutlinedIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />
//           </Box>
//           <Box display="flex" alignItems="center" justifyContent="space-between" mt="10px">
//             <Typography variant="h3" fontWeight="bold" color={colors.greenAccent[500]}>
//               {PlannedLeave}
//             </Typography>
//           </Box>
//         </Box>

//         <Box
//           backgroundColor={colors.primary[400]}
//           p="20px"
//           borderRadius="4px"
//           boxShadow={theme.shadows[1]}
//           display="flex"
//           flexDirection="column"
//         >
//           <Box display="flex" alignItems="center" justifyContent="space-between">
//             <Typography variant="h5" fontWeight="600" color={colors.grey[100]}>
//               Total Leave Balance
//             </Typography>
//             <EventOutlinedIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />
//           </Box>
//           <Box display="flex" alignItems="center" justifyContent="space-between" mt="10px">
//             <Typography variant="h3" fontWeight="bold" color={colors.greenAccent[500]}>
//               {totalBalanceLeave}
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* FORM SECTION */}
//       <Box display="flex" justifyContent="center" alignItems="center" maxWidth="900px" >
//         {!isSubmitted ? (
//           <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '900px' }}>
//             <Box
//               backgroundColor={colors.primary[400]}
//               p="20px"
//               borderRadius="4px"
//               boxShadow={theme.shadows[1]}
//             >
//               <Grid container spacing={3}>
//                 {/* Employee Info */}
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     Employee ID
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     value={employeeId}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       style: {
//                         backgroundColor: colors.primary[400],
//                         color: colors.grey[100],
//                         borderRadius: "4px"
//                       }
//                     }}

//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "& fieldset": { borderColor: colors.grey[700] },
//                         "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                         "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                       },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     Employee Name
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     value={employeeName}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       style: {
//                         backgroundColor: colors.primary[400],
//                         color: colors.grey[100],
//                         borderRadius: "4px"
//                       }
//                     }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "& fieldset": { borderColor: colors.grey[700] },
//                         "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                         "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                       },
//                     }}
//                   />
//                 </Grid>

//                 {/* Leave Type */}
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     Leave Type
//                   </Typography>
//                   <TextField
//                     select
//                     fullWidth
//                     value={leaveType}
//                     onChange={handleLeaveTypeChange}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       style: {
//                         backgroundColor: colors.primary[400],
//                         color: colors.grey[100],
//                         borderRadius: "4px"
//                       }
//                     }}

//                     SelectProps={{
//                       displayEmpty: true, // 👈 This ensures the empty value is shown as a valid display
//                     }}

//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "& fieldset": { borderColor: colors.grey[700] },
//                         "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                         "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                       },
//                     }}
//                   >
//                     <MenuItem value="" style={{ color: colors.grey[100] }}>Select Leave Type</MenuItem>
//                     <MenuItem value="EMERGENCY" style={{ color: colors.grey[100] }}>Emergency Leave</MenuItem>
//                     <MenuItem value="PLANNED" style={{ color: colors.grey[100] }}>Planned Leave</MenuItem>
//                     <MenuItem
//                       value="LWP"
//                       style={{
//                         color: (EmergencyLeave > 0 || PlannedLeave > 0) ? colors.grey[500] : colors.grey[100],
//                         backgroundColor: (EmergencyLeave > 0 || PlannedLeave > 0) ? colors.primary[700] : 'inherit'
//                       }}
//                       disabled={EmergencyLeave > 0 || PlannedLeave > 0}
//                     >
//                       Leave Without Pay
//                     </MenuItem>
//                   </TextField>
//                 </Grid>

//                 {/* Dates Section */}
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     From Date
//                   </Typography>
//                   <DatePicker
//                     selected={startDate}
//                     onChange={handleStartDateChange}
//                     dateFormat="dd-MM-yyyy"
//                     customInput={
//                       <TextField
//                         fullWidth
//                         variant="outlined"
//                         size="small"
//                         InputProps={{
//                           style: {
//                             backgroundColor: colors.primary[400],
//                             color: colors.grey[100],
//                             borderRadius: "4px"
//                           }
//                         }}
//                         sx={{
//                           "& .MuiOutlinedInput-root": {
//                             "& fieldset": { borderColor: colors.grey[700] },
//                             "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                             "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                           },
//                         }}
//                       />
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     To Date
//                   </Typography>
//                   <DatePicker
//                     selected={endDate}
//                     onChange={handleEndDateChange}
//                     minDate={startDate}
//                     dateFormat="dd-MM-yyyy"
//                     customInput={
//                       <TextField
//                         fullWidth
//                         variant="outlined"
//                         size="small"
//                         InputProps={{
//                           style: {
//                             backgroundColor: colors.primary[400],
//                             color: colors.grey[100],
//                             borderRadius: "4px"
//                           }
//                         }}
//                         sx={{
//                           "& .MuiOutlinedInput-root": {
//                             "& fieldset": { borderColor: colors.grey[700] },
//                             "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                             "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                           },
//                         }}
//                       />
//                     }
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     Total Leave Days
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     value={totalLeaveDays}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       style: {
//                         backgroundColor: colors.greenAccent[700],
//                         color: colors.grey[100],
//                         borderRadius: "4px",
//                         fontWeight: "bold"
//                       }
//                     }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "& fieldset": { borderColor: colors.grey[700] },
//                         "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                         "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                       },
//                     }}
//                   />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={isHalfDay}
//                         onChange={handleHalfDayChange}
//                         sx={{
//                           color: colors.greenAccent[500],
//                           '&.Mui-checked': {
//                             color: colors.greenAccent[500],
//                           },
//                         }}
//                       />
//                     }
//                     label={
//                       <Typography color={colors.grey[100]}>
//                         Half Day
//                       </Typography>
//                     }
//                   />
//                 </Grid>

//                 {/* Reason Section */}
//                 <Grid item xs={12}>
//                   <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                     Reason
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     value={leaveReason}
//                     onChange={handleLeaveReasonChange}
//                     variant="outlined"
//                     size="small"
//                     multiline
//                     rows={isSmallScreen ? 4 : 6}
//                     placeholder="Enter your reason for leave..."
//                     InputProps={{
//                       style: {
//                         backgroundColor: colors.primary[400],
//                         color: colors.grey[100],
//                         borderRadius: "4px"
//                       }
//                     }}
//                     sx={{
//                       "& .MuiOutlinedInput-root": {
//                         "& fieldset": { borderColor: colors.grey[700] },
//                         "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                         "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                       },
//                       "& .MuiInputBase-input::placeholder": {
//                         color: colors.grey[400],
//                         opacity: 1,
//                       },
//                     }}
//                   />
//                 </Grid>

//                 {/* File Upload */}
//                 {totalLeaveDays > 2 && (
//                   <Grid item xs={12}>
//                     <Box
//                       backgroundColor={colors.primary[400]}
//                       p="20px"
//                       borderRadius="4px"
//                       boxShadow={theme.shadows[1]}
//                     >
//                       <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>
//                         Upload Supporting Documents
//                       </Typography>
//                       <input
//                         type="file"
//                         id="file-upload"
//                         multiple
//                         onChange={handleFileChange}
//                         style={{ display: 'none' }}
//                       />
//                       <label htmlFor="file-upload">
//                         <Button
//                           variant="contained"
//                           component="span"
//                           sx={{
//                             backgroundColor: colors.blueAccent[700],
//                             color: colors.grey[100],
//                             '&:hover': {
//                               backgroundColor: colors.blueAccent[800],
//                             }
//                           }}
//                         >
//                           Select Files
//                         </Button>
//                       </label>
//                       {files.length > 0 && (
//                         <Box sx={{ mt: 2 }}>
//                           <Typography variant="h6" color={colors.grey[100]}>Selected files:</Typography>
//                           <ul style={{
//                             margin: '8px 0 0 0',
//                             paddingLeft: '20px',
//                             color: colors.grey[100]
//                           }}>
//                             {files.map((file, index) => (
//                               <li key={index}>
//                                 {file.name} ({(file.size / 1024).toFixed(2)} KB)
//                               </li>
//                             ))}
//                           </ul>
//                         </Box>
//                       )}
//                     </Box>
//                   </Grid>
//                 )}

//                 {/* Form Buttons */}
//                 <Grid item xs={12}>
//                   <Box display="flex" justifyContent="flex-end" gap="20px">
//                     <Button
//                       variant="contained"
//                       onClick={handleReset}
//                       sx={{
//                         backgroundColor: colors.redAccent[700],
//                         color: colors.grey[100],
//                         '&:hover': {
//                           backgroundColor: colors.redAccent[800],
//                         }
//                       }}
//                     >
//                       Reset
//                     </Button>
//                     <Button
//                       variant="contained"
//                       type="submit"
//                       disabled={isSubmitting}
//                       sx={{
//                         backgroundColor: colors.greenAccent[700],
//                         color: colors.grey[100],
//                         '&:hover': {
//                           backgroundColor: colors.greenAccent[800],
//                         },
//                         '&:disabled': {
//                           backgroundColor: colors.grey[700],
//                           color: colors.grey[500]
//                         }
//                       }}
//                     >
//                       {isSubmitting ? "Submitting..." : "Submit Application"}
//                     </Button>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           </form>
//         ) : (
//           <Box
//             backgroundColor={colors.primary[400]}
//             p="20px"
//             borderRadius="4px"
//             boxShadow={theme.shadows[1]}
//             width="100%"
//             maxWidth="900px"
//           >
//             <Typography variant="h3" gutterBottom color={colors.greenAccent[500]} sx={{ mb: 3, fontWeight: 'bold' }}>
//               {successMessage}
//             </Typography>

//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>Employee ID</Typography>
//                 <TextField
//                   fullWidth
//                   value={employeeId}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>Employee Name</Typography>
//                 <TextField
//                   fullWidth
//                   value={employeeName}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>Leave Type</Typography>
//                 <TextField
//                   fullWidth
//                   value={leaveType === "EMERGENCY" ? "Emergency Leave" :
//                         leaveType === "PLANNED" ? "Planned Leave" :
//                         leaveType === "LWP" ? "Leave Without Pay" : ""}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>Total Leave Days</Typography>
//                 <TextField
//                   fullWidth
//                   value={totalLeaveDays}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.greenAccent[700],
//                       color: colors.grey[100],
//                       borderRadius: "4px",
//                       fontWeight: "bold"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>From Date</Typography>
//                 <TextField
//                   fullWidth
//                   value={formatDate(startDate)}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>To Date</Typography>
//                 <TextField
//                   fullWidth
//                   value={formatDate(endDate)}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>Reason</Typography>
//                 <TextField
//                   fullWidth
//                   value={leaveReason}
//                   variant="outlined"
//                   size="small"
//                   multiline
//                   rows={isSmallScreen ? 4 : 6}
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="h5" fontWeight="600" gutterBottom color={colors.grey[100]}>Half Day</Typography>
//                 <TextField
//                   fullWidth
//                   value={isHalfDay ? "Yes" : "No"}
//                   variant="outlined"
//                   size="small"
//                   InputProps={{
//                     style: {
//                       backgroundColor: colors.primary[400],
//                       color: colors.grey[100],
//                       borderRadius: "4px"
//                     }
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       "& fieldset": { borderColor: colors.grey[700] },
//                       "&:hover fieldset": { borderColor: colors.greenAccent[500] },
//                       "&.Mui-focused fieldset": { borderColor: colors.greenAccent[500] },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" justifyContent="center">
//                   <Button
//                     variant="contained"
//                     onClick={handleReset}
//                     sx={{
//                       backgroundColor: colors.blueAccent[700],
//                       color: colors.grey[100],
//                       '&:hover': {
//                         backgroundColor: colors.blueAccent[800],
//                       }
//                     }}
//                   >
//                     Apply New Leave
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         )}
//       </Box>

//       </div>
//     </Box>
//   );
// };

// export default ApplyLeave;

import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { tokens } from "../../theme";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Header from "../../components/Header";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import { FormControl, RadioGroup, Radio } from "@mui/material";
import { Snackbar, Alert } from "@mui/material";

const ApplyLeave = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startHalfDay, setStartHalfDay] = useState(false);
  const [endHalfDay, setEndHalfDay] = useState(false);
  const [startHalfDayOption, setStartHalfDayOption] = useState("1");
  const [endHalfDayOption, setEndHalfDayOption] = useState("1");
  const [leaveType, setLeaveType] = useState("");
  const [leaveReason, setLeaveReason] = useState("");
  // const [userEmail, setUserEmail] = useState("UserEmail");
  const userEmail = localStorage.getItem("UserEmail") || "";
  const [EmergencyLeave, setEmergencyLeave] = useState(0);
  const [PlannedLeave, setPlannedLeave] = useState(0);
  const [Leavewithoutpay, setLeavewithoutpay] = useState(0);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [files, setFiles] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [leaveDurationDays, setLeaveDurationDays] = useState(0);
  const [username, setUsername] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;
  const [publicHolidays, setPublicHolidays] = useState([]);
  const [holidaysReady, setHolidaysReady] = useState(false);
  const [errors, setErrors] = useState({
    leaveType: "",
    leaveReason: "",
    fileUpload: "",
  });

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_URL_LMS}/annualleave?UserEmail=${userEmail}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error("User not available");
          }
          throw new Error("Something went wrong");
        }
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const balanceLeave = data[0];
          setUsername(balanceLeave?.username || "");
          setEmergencyLeave(balanceLeave?.emergencyleave || 0);
          setPlannedLeave(balanceLeave?.plannedleave || 0);
          setLeavewithoutpay(balanceLeave?.leavewithoutpay || 0);
        }
      })
      .catch((error) => {
        console.log(error.message);
        // Show in UI instead of alert if preferred
        alert(error.message);
      });
  }, [userEmail]);

  useEffect(() => {
    setUsername(localStorage.getItem("UserName"));
  }, []);

  useEffect(() => {
    if (userEmail) {
      fetchPublicHolidays(userEmail);
    }
  }, [userEmail]);

  useEffect(() => {
    const today = new Date();
    setStartDate(today);

    const hour = today.getHours();
    if (hour >= 13) {
      setStartHalfDay(true);
      setStartHalfDayOption("2");
    } else {
      setStartHalfDay(false);
      setStartHalfDayOption("");
    }
  }, []);

  const fetchPublicHolidays = async (userEmail) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_LMS}/get-public-holidays?email=${userEmail}`
      );
      const data = await res.json();
      if (data.status === "200") {
        setPublicHolidays(data.holidays);
        setHolidaysReady(true);
        setTimeout(() => calculateLeaveDays(), 0);
      }
    } catch (error) {
      console.error("Failed to fetch public holidays:", error);
    }
  };

  useEffect(() => {
    if (!startDate || !endDate || !holidaysReady) return;
    calculateLeaveDays();
  }, [
    startDate,
    endDate,
    startHalfDay,
    endHalfDay,
    startHalfDayOption,
    endHalfDayOption,
    leaveType,
    holidaysReady,
    leaveType,
  ]);

  const calculateWorkingDays = (
    start,
    end,
    holidays,
    isStartHalfDayChecked,
    isEndHalfDayChecked,
    startHalfDayOption,
    endHalfDayOption
  ) => {
    let days = 0;
    const startDate = new Date(start);
    const endDate = new Date(end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    let current = new Date(startDate);

    while (current <= endDate) {
      const dayStr = current.toISOString().split("T")[0];
      const isWeekend = current.getDay() === 0 || current.getDay() === 6;
      const isHoliday = holidays.includes(dayStr);

      if (!isWeekend && !isHoliday) {
        days += 1;
      }

      current.setDate(current.getDate() + 1);
    }

    const sameDay = startDate.getTime() === endDate.getTime();

    if (sameDay) {
      if (isStartHalfDayChecked && isEndHalfDayChecked) {
        days = 0; // first + second = 0
      } else if (isStartHalfDayChecked || isEndHalfDayChecked) {
        days = 0.5;
      } else {
        days = 1;
      }
    } else {
      if (isStartHalfDayChecked) {
        days -= 0.5;
      }
      if (isEndHalfDayChecked) {
        days -= 0.5;
      }
    }

    return days;
  };

  const calculateLeaveDays = () => {
    if (!startDate || !endDate) return;

    const days = calculateWorkingDays(
      startDate,
      endDate,
      publicHolidays,
      startHalfDay,
      endHalfDay,
      startHalfDayOption,
      endHalfDayOption
    );

    setLeaveDurationDays(days);

    if (leaveType === "EMERGENCY" && days > 2) {
      setShowFileUpload(true);
    } else if (leaveType === "PLANNED" && days > 5) {
      setShowFileUpload(true);
    } else {
      setShowFileUpload(false);
    }
  };

  const handleStartDateChange = (date) => {
    processStartDateChange(date);
    setStartDate(date);
  };

  const processStartDateChange = (date) => {
    const today = new Date();
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    if (isToday) {
      const currentHour = today.getHours();
      if (currentHour >= 13) {
        setStartHalfDay(true);
        setStartHalfDayOption("2");
      } else {
        setStartHalfDay(false);
        setStartHalfDayOption("");
      }
    } else {
      setStartHalfDay(false);
      setStartHalfDayOption("");
    }

    if (endDate && date > endDate) {
      setEndDate(null);
      setEndHalfDay(false);
      setEndHalfDayOption("");
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && date.getTime() === startDate.getTime()) {
      setEndHalfDay(startHalfDay);
      setEndHalfDayOption(startHalfDayOption);
    } else {
      setEndHalfDay(false);
      setEndHalfDayOption("");
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleStartHalfDayChange = () => {
    const newVal = !startHalfDay;
    setStartHalfDay(newVal);
    setStartHalfDayOption(newVal ? "1" : "");
  };

  const handleEndHalfDayChange = () => {
    const newVal = !endHalfDay;
    setEndHalfDay(newVal);
    setEndHalfDayOption(newVal ? "1" : "");
  };

  const handleStartHalfDayOptionChange = (e) => {
    setStartHalfDayOption(e.target.value);
    // setTimeout(() => calculateLeaveDays(), 0);
  };

  const handleEndHalfDayOptionChange = (e) => {
    setEndHalfDayOption(e.target.value);
    // setTimeout(() => calculateLeaveDays(), 0);
  };

  const handleLeaveTypeChange = (e) => {
    setLeaveType(e.target.value);
    setErrors((prev) => ({ ...prev, leaveType: "" }));
  };

  const handleLeaveReasonChange = (e) => {
    setLeaveReason(e.target.value);
    setErrors((prev) => ({ ...prev, leaveReason: "" }));
  };

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.oasis.opendocument.text",
    "text/plain",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/svg+xml",
  ];

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = [];
    const invalidFiles = [];

    selectedFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (validFiles.length === 0 && invalidFiles.length > 0) {
      setErrors((prev) => ({
        ...prev,
        fileUpload: `Invalid file type(s): ${invalidFiles.join(", ")}`,
      }));
    } else {
      setErrors((prev) => ({ ...prev, fileUpload: "" }));
    }

    setFiles(validFiles);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const newErrors = {
      leaveType: "",
      leaveReason: "",
      fileUpload: "",
    };

    if (!leaveType) {
      newErrors.leaveType = "Please select leave type.";
    }
    if (!leaveReason) {
      newErrors.leaveReason = "Please enter leave reason.";
    }
    if (
      showFileUpload &&
      files.length === 0 &&
      leaveType.toLowerCase().includes("emergency")
    ) {
      newErrors.fileUpload = "Please upload a file for emergency leave.";
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some((err) => err !== "")) {
      setIsSubmitting(false);
      return; // Stop submission if any error exists
    }

    const formData = new FormData();
    formData.append("leaveType", leaveType);
    formData.append(
      "startDate",
      startDate.getDate() +
        "-" +
        (startDate.getMonth() + 1) +
        "-" +
        startDate.getFullYear()
    );
    formData.append(
      "endDate",
      endDate.getDate() +
        "-" +
        (endDate.getMonth() + 1) +
        "-" +
        endDate.getFullYear()
    );
    formData.append(
      "startHalfDayOption",
      startHalfDay ? startHalfDayOption : "0"
    );
    formData.append("endHalfDayOption", endHalfDay ? endHalfDayOption : "0");
    formData.append("leaveReason", leaveReason);
    formData.append("userEmail", userEmail);
    formData.append("username", username);
    formData.append("isStartHalfDay", startHalfDay);
    formData.append("isEndHalfDay", endHalfDay);

    files.forEach((file, index) => {
      formData.append(`file${index + 1}`, file);
    });

    try {
      let apiEndpoint = `${process.env.REACT_APP_BACKEND_URL_LMS}/ApplyLeave`;

      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (response.status === 400) {
        handleReset();
        setSnackbarMessage(data.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      if (response.ok) {
        setFormData(formData);
        setSuccessMessage(data.message);
        setSnackbarMessage(data.message);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setIsSubmitted(true);
      } else {
        setErrorMessage(data.message);
        handleReset();
        setSnackbarMessage(data.message || "Something went wrong");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      handleReset();
      setSnackbarMessage("Network error or internal issue.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
    setIsSubmitting(false);
  };

  const handleReset = () => {
    setLeaveType("");
    setLeaveReason("");
    setStartDate(null);
    setEndDate(null);
    setStartDate(new Date());
    setEndDate(new Date());
    setStartHalfDayOption("0");
    setEndHalfDayOption("0");
    setLeaveType("");
    setLeaveReason("");
    setFiles([]);
    setErrors({});
    setShowFileUpload(false);
    setIsSubmitted(false);
    setIsSubmitting(false);
    setSuccessMessage("");
  };

  const handleback = () => {
    setIsSubmitted(false);
    handleReset();
  };

  const formatDate = (date) => {
    return (
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
    );
  };

  if (isSubmitted) {
    return (
      <Box m="20px">
        <Box
          backgroundColor={colors.primary[400]}
          p="20px"
          borderRadius="4px"
          boxShadow={theme.shadows[1]}
          width="100%"
          maxWidth="900px"
          margin="0 auto"
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            variant="filled"
            sx={{
              mb: 3,
              width: "100%",
              fontSize: "1.1rem",
              backgroundColor:
                snackbarSeverity === "success"
                  ? colors.greenAccent[600]
                  : colors.redAccent[600],
              color: colors.grey[100],
              borderRadius: "4px",
            }}
          >
            {snackbarMessage}
          </Alert>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                fontWeight="600"
                gutterBottom
                color={colors.grey[100]}
              >
                Employee Email
              </Typography>
              <TextField
                fullWidth
                value={userEmail}
                variant="outlined"
                size="small"
                InputProps={{
                  style: {
                    backgroundColor: colors.primary[400],
                    color: colors.grey[100],
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: colors.grey[700] },
                    "&:hover fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                fontWeight="600"
                gutterBottom
                color={colors.grey[100]}
              >
                Employee Name
              </Typography>
              <TextField
                fullWidth
                value={username}
                variant="outlined"
                size="small"
                InputProps={{
                  style: {
                    backgroundColor: colors.primary[400],
                    color: colors.grey[100],
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: colors.grey[700] },
                    "&:hover fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                fontWeight="600"
                gutterBottom
                color={colors.grey[100]}
              >
                Leave Type
              </Typography>
              <TextField
                fullWidth
                value={leaveType}
                variant="outlined"
                size="small"
                InputProps={{
                  style: {
                    backgroundColor: colors.primary[400],
                    color: colors.grey[100],
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: colors.grey[700] },
                    "&:hover fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                fontWeight="600"
                gutterBottom
                color={colors.grey[100]}
              >
                From Date
              </Typography>
              <TextField
                fullWidth
                value={formatDate(startDate)}
                variant="outlined"
                size="small"
                InputProps={{
                  style: {
                    backgroundColor: colors.primary[400],
                    color: colors.grey[100],
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: colors.grey[700] },
                    "&:hover fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                fontWeight="600"
                gutterBottom
                color={colors.grey[100]}
              >
                To Date
              </Typography>
              <TextField
                fullWidth
                value={formatDate(endDate)}
                variant="outlined"
                size="small"
                InputProps={{
                  style: {
                    backgroundColor: colors.primary[400],
                    color: colors.grey[100],
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: colors.grey[700] },
                    "&:hover fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="h5"
                fontWeight="600"
                gutterBottom
                color={colors.grey[100]}
              >
                Reason
              </Typography>
              <TextField
                fullWidth
                value={leaveReason}
                variant="outlined"
                size="small"
                multiline
                rows={4}
                InputProps={{
                  style: {
                    backgroundColor: colors.primary[400],
                    color: colors.grey[100],
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: colors.grey[700] },
                    "&:hover fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: colors.greenAccent[500],
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center">
                <Button
                  variant="contained"
                  onClick={handleback}
                  sx={{
                    backgroundColor: colors.blueAccent[700],
                    color: colors.grey[100],
                    "&:hover": {
                      backgroundColor: colors.blueAccent[800],
                    },
                  }}
                >
                  Apply New Leave
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box
        display="flex"
        flexDirection={isSmallScreen ? "column" : "row"}
        justifyContent="space-between"
        alignItems={isSmallScreen ? "flex-start" : "center"}
      >
        <Header title="APPLY LEAVE" subtitle="Submit a new leave application" />
      </Box>

      {/* LEAVE BALANCE CARDS */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Box
          display="grid"
          gridTemplateColumns={isSmallScreen ? "1fr" : "repeat(3, 1fr)"}
          gap="20px"
          mb="20px"
          width="100%"
          maxWidth="900px"
        >
          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="4px"
            boxShadow={theme.shadows[1]}
            display="flex"
            flexDirection="column"
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="h5"
                fontWeight="600"
                color={colors.grey[100]}
              >
                Emergency Leave
              </Typography>
              <EventOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt="10px"
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                color={colors.greenAccent[500]}
              >
                {EmergencyLeave}
              </Typography>
            </Box>
          </Box>

          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="4px"
            boxShadow={theme.shadows[1]}
            display="flex"
            flexDirection="column"
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="h5"
                fontWeight="600"
                color={colors.grey[100]}
              >
                Planned Leave
              </Typography>
              <EventOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt="10px"
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                color={colors.greenAccent[500]}
              >
                {PlannedLeave}
              </Typography>
            </Box>
          </Box>

          <Box
            backgroundColor={colors.primary[400]}
            p="20px"
            borderRadius="4px"
            boxShadow={theme.shadows[1]}
            display="flex"
            flexDirection="column"
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="h5"
                fontWeight="600"
                color={colors.grey[100]}
              >
                Leave Without Pay
              </Typography>
              <EventOutlinedIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt="10px"
            >
              <Typography
                variant="h3"
                fontWeight="bold"
                color={colors.greenAccent[500]}
              >
                {Leavewithoutpay}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* FORM SECTION */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          maxWidth="900px"
          width="100%"
        >
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Box
              backgroundColor={colors.primary[400]}
              p="20px"
              borderRadius="4px"
              boxShadow={theme.shadows[1]}
            >
              <Grid container spacing={3}>
                {/* Employee Info */}
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h5"
                    fontWeight="600"
                    gutterBottom
                    color={colors.grey[100]}
                  >
                    Employee Email
                  </Typography>
                  <TextField
                    fullWidth
                    value={userEmail}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      style: {
                        backgroundColor: colors.primary[400],
                        color: colors.grey[100],
                        borderRadius: "4px",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: colors.grey[700] },
                        "&:hover fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h5"
                    fontWeight="600"
                    gutterBottom
                    color={colors.grey[100]}
                  >
                    Employee Name
                  </Typography>
                  <TextField
                    fullWidth
                    value={username}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      style: {
                        backgroundColor: colors.primary[400],
                        color: colors.grey[100],
                        borderRadius: "4px",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: colors.grey[700] },
                        "&:hover fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                      },
                    }}
                  />
                </Grid>

                {/* Leave Type */}
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h5"
                    fontWeight="600"
                    gutterBottom
                    color={colors.grey[100]}
                  >
                    Leave Type{" "}
                    <span style={{ color: "red", fontSize: "20px" }}> *</span>
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    value={leaveType}
                    error={!!errors.leaveType}
                    helperText={errors.leaveType}
                    onChange={handleLeaveTypeChange}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      style: {
                        backgroundColor: colors.primary[400],
                        color: colors.grey[100],
                        borderRadius: "4px",
                      },
                    }}
                    SelectProps={{
                      displayEmpty: true,
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            bgcolor: colors.primary[900],
                            color: colors.grey[100],
                            boxShadow: "none",
                            backgroundImage: "none",
                            boxShadow: `0px 4px 10px ${colors.primary[900]}`,
                            borderRadius: "4px",
                            "& .MuiMenuItem-root": {
                              backgroundColor: colors.primary[900],
                              color: colors.grey[100],
                              "&:hover": {
                                backgroundColor: colors.greenAccent[600],
                                color: colors.black,
                              },
                              "&.Mui-selected": {
                                backgroundColor: colors.primary[900],
                                color: colors.grey[100],
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: colors.greenAccent[600],
                                color: colors.black,
                              },
                            },
                          },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: colors.grey[700] },
                        "&:hover fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                      },
                    }}
                  >
                    <MenuItem value="">Select Leave Type</MenuItem>
                    <MenuItem value="EMERGENCY">Emergency Leave</MenuItem>
                    <MenuItem value="PLANNED">Planned Leave</MenuItem>
                    <MenuItem value="Tentative_Leave_Plan">
                      Tentative Leave Plan
                    </MenuItem>
                  </TextField>
                </Grid>

                <>
                  {/* Dates Section */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="h5"
                      fontWeight="600"
                      gutterBottom
                      color={colors.grey[100]}
                    >
                      From Date{" "}
                      <span style={{ color: "red", fontSize: "20px" }}> *</span>
                    </Typography>
                    <DatePicker
                      selected={startDate}
                      onChange={handleStartDateChange}
                      dateFormat="dd-MM-yyyy"
                      minDate={leaveType === "PLANNED" ? new Date() : undefined}
                      calendarClassName="custom-calendar"
                      dayClassName={() => "custom-day"}
                      customInput={
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputProps={{
                            style: {
                              backgroundColor: colors.primary[400],
                              color: colors.grey[100],
                              borderRadius: "4px",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": { borderColor: colors.grey[700] },
                              "&:hover fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                            },
                          }}
                        />
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="h5"
                      fontWeight="600"
                      gutterBottom
                      color={colors.grey[100]}
                    >
                      To Date{" "}
                      <span style={{ color: "red", fontSize: "20px" }}> *</span>
                    </Typography>
                    <DatePicker
                      selected={endDate}
                      onChange={handleEndDateChange}
                       minDate={startDate || (leaveType === "PLANNED" ? new Date() : undefined)} 
                      dateFormat="dd-MM-yyyy"
                      calendarClassName="custom-calendar"
                      dayClassName={() => "custom-day"}
                      customInput={
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputProps={{
                            style: {
                              backgroundColor: colors.primary[400],
                              color: colors.grey[100],
                              borderRadius: "4px",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": { borderColor: colors.grey[700] },
                              "&:hover fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: colors.greenAccent[500],
                              },
                            },
                          }}
                        />
                      }
                    />
                  </Grid>

                  <style>
                    {`
                      .custom-calendar {
                        background-color: ${colors.primary[900]};
                        color: ${colors.grey[100]};
                        border: none;
                        box-shadow: 0px 8px 24px ${colors.primary[900]};
                        border-radius: 8px;
                      }

                      .custom-calendar .react-datepicker__header {
                        background-color: ${colors.primary[900]};
                        border-bottom: 1px solid ${colors.grey[700]};
                      }

                      .custom-calendar .react-datepicker__day,
                      .custom-calendar .react-datepicker__day-name,
                      .custom-calendar .react-datepicker__current-month {
                        color: ${colors.grey[100]};
                      }

                      .custom-calendar .react-datepicker__day:hover {
                        background-color: ${colors.greenAccent[500]};
                        color: ${colors.black};
                        border-radius: 4px;
                      }

                      .custom-calendar .react-datepicker__day--selected,
                      .custom-calendar .react-datepicker__day--keyboard-selected {
                        background-color: ${colors.greenAccent[500]};
                        color: ${colors.black};
                        border-radius: 4px;
                      }

                      .custom-calendar .react-datepicker__triangle {
                        display: none; /* hides white arrow */
                      }

                      .custom-calendar .react-datepicker__navigation-icon::before {
                        border-color: ${colors.grey[100]};
                      }
                    `}
                  </style>
                </>

                {/* Half Day Options */}
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={startHalfDay}
                        onChange={handleStartHalfDayChange}
                        sx={{
                          color: colors.greenAccent[500],
                          "&.Mui-checked": {
                            color: colors.greenAccent[500],
                          },
                        }}
                      />
                    }
                    label={
                      <Typography color={colors.grey[100]}>
                        Start Date Half Day
                      </Typography>
                    }
                  />
                  {startHalfDay && (
                    <Box mt={1} ml={3}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          value={startHalfDayOption}
                          onChange={handleStartHalfDayOptionChange}
                        >
                          <FormControlLabel
                            value="1"
                            control={
                              <Radio
                                sx={{
                                  color: colors.greenAccent[500],
                                  "&.Mui-checked": {
                                    color: colors.greenAccent[500],
                                  },
                                }}
                              />
                            }
                            label={
                              <Typography color={colors.grey[100]}>
                                First Half
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="2"
                            control={
                              <Radio
                                sx={{
                                  color: colors.greenAccent[500],
                                  "&.Mui-checked": {
                                    color: colors.greenAccent[500],
                                  },
                                }}
                              />
                            }
                            label={
                              <Typography color={colors.grey[100]}>
                                Second Half
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  )}
                </Grid>

                {startDate &&
                  endDate &&
                  startDate.toDateString() !== endDate.toDateString() && (
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={endHalfDay}
                            onChange={handleEndHalfDayChange}
                            sx={{
                              color: colors.greenAccent[500],
                              "&.Mui-checked": {
                                color: colors.greenAccent[500],
                              },
                            }}
                          />
                        }
                        label={
                          <Typography color={colors.grey[100]}>
                            End Date Half Day
                          </Typography>
                        }
                      />
                      {endHalfDay && (
                        <Box mt={1} ml={3}>
                          <FormControl component="fieldset">
                            <RadioGroup
                              value={endHalfDayOption}
                              onChange={handleEndHalfDayOptionChange}
                            >
                              <FormControlLabel
                                value="1"
                                control={
                                  <Radio
                                    sx={{
                                      color: colors.greenAccent[500],
                                      "&.Mui-checked": {
                                        color: colors.greenAccent[500],
                                      },
                                    }}
                                  />
                                }
                                label={
                                  <Typography color={colors.grey[100]}>
                                    First Half
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                value="2"
                                control={
                                  <Radio
                                    sx={{
                                      color: colors.greenAccent[500],
                                      "&.Mui-checked": {
                                        color: colors.greenAccent[500],
                                      },
                                    }}
                                  />
                                }
                                label={
                                  <Typography color={colors.grey[100]}>
                                    Second Half
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      )}
                    </Grid>
                  )}

                {/* Reason Section */}
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    fontWeight="600"
                    gutterBottom
                    color={colors.grey[100]}
                  >
                    Reason
                    <span style={{ color: "red", fontSize: "20px" }}> *</span>
                  </Typography>
                  <TextField
                    fullWidth
                    value={leaveReason}
                    onChange={handleLeaveReasonChange}
                    variant="outlined"
                    size="small"
                    multiline
                    rows={isSmallScreen ? 4 : 6}
                    placeholder="Enter your reason for leave..."
                    error={!!errors.leaveReason}
                    helperText={errors.leaveReason}
                    InputProps={{
                      style: {
                        backgroundColor: colors.primary[400],
                        color: colors.grey[100],
                        borderRadius: "4px",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: colors.grey[700] },
                        "&:hover fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: colors.greenAccent[500],
                        },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: colors.grey[400],
                        opacity: 1,
                      },
                    }}
                  />
                </Grid>

                {/* File Upload */}
                {showFileUpload && (
                  <Grid item xs={12}>
                    <Box
                      backgroundColor={colors.primary[400]}
                      p="20px"
                      borderRadius="4px"
                      boxShadow={theme.shadows[1]}
                    >
                      <Typography
                        variant="h5"
                        fontWeight="600"
                        gutterBottom
                        color={colors.grey[100]}
                      >
                        Upload Supporting Documents{" "}
                        {leaveType.toLowerCase().includes("emergency") && (
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *
                          </span>
                        )}
                      </Typography>
                      {leaveType === "EMERGENCY" &&
                        startDate &&
                        endDate &&
                        leaveDurationDays >= 2 && (
                          <Typography
                            variant="h6"
                            color={colors.grey[100]}
                            sx={{ mb: 2 }}
                          >
                            You are applying {leaveDurationDays} days of
                            emergency leave. Please upload documents (images or
                            PDF) as evidence to process your request.
                          </Typography>
                        )}

                      {leaveType === "PLANNED" &&
                        startDate &&
                        endDate &&
                        leaveDurationDays > 5 && (
                          <Typography
                            variant="h6"
                            color={colors.grey[100]}
                            sx={{ mb: 2 }}
                          >
                            You are applying {leaveDurationDays} days of planned
                            leave. Please upload documents (images or PDF) as
                            evidence to process your request.
                          </Typography>
                        )}

                      <input
                        type="file"
                        id="file-upload"
                        multiple
                        onChange={handleFileChange}
                        accept={allowedTypes.join(',')}
                        style={{ display: "none" }}
                      />
                      <label htmlFor="file-upload">
                        <Button
                          variant="contained"
                          component="span"
                          sx={{
                            backgroundColor: colors.blueAccent[700],
                            color: colors.grey[100],
                            "&:hover": {
                              backgroundColor: colors.blueAccent[800],
                            },
                          }}
                        >
                          Select Files
                        </Button>
                      </label>
                      {files.length > 0 && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="h6" color={colors.grey[100]}>
                            Selected files:
                          </Typography>
                          <ul
                            style={{
                              margin: "8px 0 0 0",
                              paddingLeft: "20px",
                              color: colors.grey[100],
                            }}
                          >
                            {files.map((file, index) => (
                              <li key={index}>
                                {file.name} ({(file.size / 1024).toFixed(2)} KB)
                              </li>
                            ))}
                          </ul>
                        </Box>
                      )}
                      {errors.fileUpload && (
                        <Typography
                          variant="body2"
                          color="error"
                          sx={{ mt: 1 }}
                        >
                          {errors.fileUpload}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                )}

                <Snackbar
                  open={snackbarOpen}
                  autoHideDuration={5000}
                  onClose={handleSnackbarClose}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  sx={{
                    maxWidth: "850px",
                    width: "75%",
                    margin: "0 auto",
                  }}
                >
                  <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    variant="filled"
                    sx={{
                      width: "100%",
                      fontSize: "1.1rem",
                      fontWeight: 500,
                      padding: "12px 20px",
                    }}
                  >
                    {snackbarMessage}
                  </Alert>
                </Snackbar>

                {/* Form Buttons */}
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="flex-end" gap="20px">
                    <Button
                      variant="contained"
                      onClick={handleReset}
                      sx={{
                        backgroundColor: colors.redAccent[700],
                        color: colors.grey[100],
                        "&:hover": {
                          backgroundColor: colors.redAccent[800],
                        },
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        backgroundColor: colors.greenAccent[700],
                        color: colors.grey[100],
                        "&:hover": {
                          backgroundColor: colors.greenAccent[800],
                        },
                        "&:disabled": {
                          backgroundColor: colors.grey[700],
                          color: colors.grey[500],
                        },
                      }}
                    >
                      {isSubmitting ? "Submitting..." : "Submit Application"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ApplyLeave;
